import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  mergeRow,
  safeText,
  setCell,
} from "./principle6SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Initiative to improve resource";

const SHEET_TITLE =
  "Details of specific initiatives or innovative technology or solutions to improve resource efficiency, or reduce impact due to emissions / effluent discharge / waste generated";

export function buildInitiativeToImproveResourceSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 24;
  ws.getColumn("F").width = 28;
  ws.getColumn("G").width = 20;
  ws.getColumn("H").width = 24;

  const rows = sectionC?.principle6?.leadershipIndicator?.spcificIntiativesorUsedInnovative || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_6, { mergeEnd: COL_H });

  mergeRow(ws, TITLE_ROW, COL_D, COL_H, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Initiative undertaken", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_F, "Details of initiative", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_G, "Weblink", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_H, "Outcome of the initiative", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.intiativeundertaken), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.detail), { align: "left" });
    setCell(ws, row, COL_G, safeText(item?.webLink), { align: "left" });
    setCell(ws, row, COL_H, safeText(item?.outCome), { align: "left" });
  });

  return ws;
}
